import axios from "axios";
import {
	DOC_INIT,
	GET_DOCS_FAILED,
	GET_DOCS_REQ_FAILED,
	GET_DOCS_REQ_LOADING,
	GET_DOCS_REQ_SUCCESSED,
	GET_DOCS_SUCCESSED,
	GET_OFFICE_DOCS_FAILED,
	GET_OFFICE_DOCS_SUCCESSED,
	GET_ONE_DOCS_FAILED,
	GET_ONE_DOCS_SUCCESSED
} from "../actions/types";
import { IP } from "../config/IP";

export  const initDocs=()=>(dispatch)=>
{
	dispatch({type:DOC_INIT})

}

export const getDocsReq = (listdata) => (dispatch) => {
	console.log("getDocs data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	let query = {};

	query = {
		office_id: listdata.office_id,
		companyId: listdata.companyId,
		page: listdata.page,
		limit: listdata.limit,
		action: listdata.action,
		actingOffices: listdata.actingOffices,
		assistant_offices:listdata.assistant_offices
	};

	if (listdata.searchKey) {
		query = {
			office_id: listdata.office_id,
			companyId: listdata.companyId,
			page: listdata.page,
			limit: listdata.limit,
			action: listdata.action,
			actingOffices: listdata.actingOffices,
			assistant_offices:listdata.assistant_offices,
			searchKey: listdata.searchKey,
		};
	}
	if (listdata.filterDocId) {
		query = {
			office_id: listdata.office_id,
			companyId: listdata.companyId,
			page: listdata.page,
			limit: listdata.limit,
			action: listdata.action,
			actingOffices: listdata.actingOffices,
			assistant_offices:listdata.assistant_offices,
			filterDocId: listdata.filterDocId,
		};
	}

	console.log("getDocsReq query=", query);

	dispatch({
		type: GET_DOCS_REQ_LOADING,
	});

	axios
		.post(listdata.url, query, config)
		.then((response) => {
			console.log("getDocs=", response);
			return dispatch({
				type: GET_DOCS_REQ_SUCCESSED,
				payload: response,
			});
		})
		.catch((error) => {
			console.log("getDocs error=", error);
			return dispatch({
				type: GET_DOCS_REQ_FAILED,
				payload: error,
			});
		});
};
export const getDocs = (listdata) => (dispatch) => {
	console.log("getDocs data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(
			listdata.url,
			{
				office_id: listdata.office_id,
				companyId: listdata.companyId,
				actingOffices: listdata.actingOffices,
				assistant_offices:listdata.assistant_offices
			},
			config
		)
		.then((response) => {
			console.log("getDocs=", response);
			return dispatch({
				type: GET_DOCS_SUCCESSED,
				payload: response,
			});
		})
		.catch((error) => {
			console.log("getDocs error=", error);
			return dispatch({
				type: GET_DOCS_FAILED,
				payload: error,
			});
		});
};

export const getDocsById = (query) => (dispatch) => {
	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	let inquery = "";
	if (query.id) {
		inquery = { id: query.id, companyId: query.companyId };
	} else if (query.office_id) {
		inquery = { office_id: query.office_id, companyId: query.companyId };
	}

	axios
		.post(IP.nodeServer + "api/getDocs", inquery, config)
		.then((response) => {
			if (response.data) {
				console.log("axios DocId=", query);
				console.log("axios response=", response);
				let doclist = response.data;
				let docsin = [];
				let respCondition = false;

				let data = [];
				let files = [response.data.file];
				console.log("doclist=", doclist);
				doclist.docs.map((doclist) => {
					if (doclist.historySituation.length > 0) {
						respCondition = true;
					}
					data.push({
						DocName: doclist.DocName,
						DocType: doclist.DocType,
						currentOfficeLocation:
							doclist.currentSituation.currentOfficeLocation,
						direction: doclist.currentSituation.direction,
						status: doclist.currentSituation.status,
						statusDescription: doclist.currentSituation.statusDescription,
						statusDate: doclist.currentSituation.statusDate,
						action: doclist.currentSituation.action,
						actionDate: doclist.currentSituation.actionDate,
						id: doclist._id,
						comments: doclist.comments,
						StepProgress: doclist.StepProgress,
						historySituation: doclist.historySituation,
						deleteDisabled: true,
					});
				});
				docsin = {
					title: "Available Documents",
					columns: [
						{ title: "DocName", field: "DocName" },
						{ title: "DocType", field: "DocType" },
						{
							title: "currentOfficeLocation",
							field: "currentOfficeLocation",
						},
						{ title: "direction", field: "direction" },
						{ title: "statusDescription", field: "statusDescription" },
						{ title: "statusDate", field: "statusDate" },
						{ title: "action", field: "action" },
						{ title: "actionDate", field: "actionDate" },
						{ title: "id", field: "id" },
					],
					data: data,
				};
				console.log("docsin=", docsin);

				return dispatch({
					type: GET_ONE_DOCS_SUCCESSED,
					payload: {
						data: docsin,
						files: files,
					},
				});
			}
		})
		.catch((error) => {
			console.log("error=", error);
			return dispatch({
				type: GET_ONE_DOCS_FAILED,
				payload: error,
			});
		});
};

export const getDocsByOffice = (query) => (dispatch) => {
	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	let inquery = "";
	if (query.id) {
		inquery = { id: query.id, companyId: query.companyId };
	} else if (query.office_id) {
		inquery = {
			office_id: query.office_id,
			companyId: query.companyId,
			actingOffices: query.actingOffices,
			assistant_offices:query.assistant_offices
		};
	}

	axios
		.post(IP.nodeServer + "api/getDocs", inquery, config)
		.then((response) => {
			if (response.data) {
				console.log("axios DocId=", query);
				console.log("axios response=", response);
				let doclist = response.data;
				let docsin = [];
				let respCondition = false;

				let data = [];
				let files = [response.data.file];
				console.log("doclist=", doclist);
				doclist.docs.map((doclist) => {
					if (doclist.historySituation.length > 0) {
						respCondition = true;
					}
					data.push({
						DocName: doclist.DocName,
						DocType: doclist.DocType,
						currentOfficeLocation:
							doclist.currentSituation.currentOfficeLocation,
						direction: doclist.currentSituation.direction,
						status: doclist.currentSituation.status,
						statusDescription: doclist.currentSituation.statusDescription,
						statusDate: doclist.currentSituation.statusDate,
						action: doclist.currentSituation.action,
						actionDate: doclist.currentSituation.actionDate,
						id: doclist._id,
						comments: doclist.comments,
						StepProgress: doclist.StepProgress,
						historySituation: doclist.historySituation,
						deleteDisabled: true,
					});
				});
				docsin = {
					title: "Available Documents",
					columns: [
						{ title: "DocName", field: "DocName" },
						{ title: "DocType", field: "DocType" },
						{
							title: "currentOfficeLocation",
							field: "currentOfficeLocation",
						},
						{ title: "direction", field: "direction" },
						{ title: "statusDescription", field: "statusDescription" },
						{ title: "statusDate", field: "statusDate" },
						{ title: "action", field: "action" },
						{ title: "actionDate", field: "actionDate" },
						{ title: "id", field: "id" },
					],
					data: data,
				};
				console.log("docsin=", docsin);

				return dispatch({
					type: GET_OFFICE_DOCS_SUCCESSED,
					payload: {
						data: docsin,
						files: files,
					},
				});
			}
		})
		.catch((error) => {
			console.log("error=", error);
			return dispatch({
				type: GET_OFFICE_DOCS_FAILED,
				payload: error,
			});
		});
};
